import type { MessageStatus } from '../api/types';
import { IconAlert, IconCheck, IconChecks, IconClock } from './Icons';

const LABEL: Record<MessageStatus, string> = {
  sending: 'Отправляется',
  sent: 'Отправлено',
  delivered: 'Доставлено',
  read: 'Прочитано',
  failed: 'Ошибка отправки',
};

export function StatusIcon({ status }: { status: MessageStatus }) {
  const icon =
    status === 'sending' ? (
      <IconClock size={14} />
    ) : status === 'failed' ? (
      <IconAlert size={14} />
    ) : status === 'sent' ? (
      <IconCheck size={15} />
    ) : (
      <IconChecks size={16} />
    );
  return (
    <span className={`status status-${status}`} title={LABEL[status]} aria-label={LABEL[status]}>
      {icon}
    </span>
  );
}
